export default {
  AuthButtonStyle: {
    background: '#179B8C',
    borderRadius: '22.5px',
    height: '45px',
    width: '200px',
    margin: 'auto',
    display: 'inline-block',
    '&:hover': {
      background: '#179B8C'
    },
    '@media (max-width: 767px)': {
      display: 'block',
    }
  },
  AuthButtonLabelStyle: {
    fontFamily: 'museosansrounded_500',
    fontSize: '14px',
    letterSpacing: '0.3px',
    textTransform: 'none'
  },
  inputStyle: {
    borderBottom: '#cecece 2px solid',
    '&::placeholder': {
      color: '#cecece'
    }
  },
  modalStyleVerifyEmail: {
    titleStyle: { textAlign: 'center', marginTop: '19px' },
    paperStyle: { borderRadius: '10px', maxWidth: '680px', width: '100%' },
    titleContainerStyle: { paddingLeft: 20, paddingRight: 20 },
    childrenStyle: {
      overflowY: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      paddingBottom: 73
    },
    containerStyle: { zIndex: 999999999 }
  },
};



// WEBPACK FOOTER //
// ./src/views/ActivatePartner/Auth/style.js